<script>
import ModalBus from '@/eventBus'
import Modal from '@/components/Modal'
import { shallowRef } from 'vue'

export default {
  components: { Modal },

  data() {
    return {
      isOpen: false,
      component: null,
      props: null,
    }
  },

  created() {
    ModalBus.on('open', ({ component, props = null }) => {
      this.component = shallowRef(component)
      this.props = props
      this.isOpen = true
    })

    ModalBus.on('close', () => this.handleClose())
  },

  methods: {
    handleClose: function () {
      this.isOpen = false
      setTimeout(() => ModalBus.emit('closed'), 600)
    },
  },
}
</script>

<template>
  <Modal
    :is-open="isOpen"
    @close="handleClose">
    <component
      :is="component"
      v-bind="props"
      @close="handleClose" />
  </Modal>
</template>
